/*!
 * devextreme-vue
 * Version: 24.1.5
 * Build date: Mon Aug 12 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

import * as VueType from 'vue';
export function getVueVersion() {
    const currentVersion = VueType.version;
    return currentVersion ? Number(currentVersion.split('.')[0]) : 2;
}
export function isVue3() {
    return getVueVersion() === 3;
}
